/* eslint-disable */
import router from '@/router/index.js'

const MODULE = {
  actions: {
    authorizedFetch: async (context, { method, endpoint, body = null, queryParams = '' }) => {
      // convert queryParams object to a URLSearchParam
      if (queryParams !== '') {
        queryParams = new URLSearchParams(queryParams).toString()
        queryParams = '?' + queryParams
      }

      if (body !== null) {
        body = JSON.stringify(body)
      }

      const url = process.env.VUE_APP_API_BASE + endpoint + queryParams
      const response = await fetch(url, {
        method: method,
        body: body,
        // injects the bearer token on any fetch
        // headers: new Headers({
        //   Authorization: context.rootState.auth.bearerToken
        // })
        credentials: 'include',
        redirect: 'follow',
        referrerPolicy: 'no-referrer'
      })

      if (response.status === 401) {
        console.log('401')
        router.push('/login')
      } else {
        // convert to json before sending
        return await response.json()
      }
    },

    getAvatarFromUserName: (context, userName) => {
      const colors = [
        'pink', 'blue', 'red', 'green',
        'brown', 'cyan', 'purple', 'deep-purple',
        'indigo', 'light-blue', 'teal', 'light-green',
        'lime', 'orange', 'blue-grey', 'grey'
      ]
      const name = userName.split(' ')
      const initials = name.map(n => n[0]).join('').toUpperCase().substring(0, 2)

      // use the UTF-16 character code of the first character of the name to determine color
      const utf16Code = userName.charCodeAt(0) % colors.length

      return {
        initials: initials,
        color: colors[utf16Code]
      }
    }
  }
}

export default MODULE
